<app-navbar />
<main>
   <section
      class="text-center relative overflow-hidden md:py-36 py-24 min-h-screen
   after:content-['']
   after:absolute
   after:inset-0
   after:mx-auto
   after:size-[56rem]
   after:bg-gradient-to-tl after:to-cyan-100/60  after:from-orange-100/50 dark:after:to-cyan-600/30 dark:after:from-indigo-600/30 after:blur-[200px] after:rounded-full after:-z-1"
      id="home">
      <div class="container relative">
         <h1 class="font-bold tracking-tight text-4xl lg:text-5xl mb-4 lg:leading-tight leading-tight">
            {{ 'pages.index-page.welcome' | translate }}
         </h1>
         <p class="max-w-2xl mx-auto mb-8 text-slate-600 dark:text-slate-300">{{ 'pages.index-page.subtitle' | translate }}</p>

         @if (!shop) {
            <!-- Try it on your shop -->
            <form (ngSubmit)="tryShop()" class="max-w-2xl mx-auto flex flex-col sm:flex-row gap-2">
               <input id="shop-url" type="text" name="address" required [(ngModel)]="address" placeholder="shop.bg"
                  inputmode="url" autocomplete="url" [attr.aria-label]="'pages.index-page.try.label' | translate"
                  class="min-w-0 flex-1 border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-cyan-500" />
               <button type="submit" [disabled]="reading"
                  class="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-xl px-6 py-3 transition">
                  @if (reading) {
                     <div class="spinner spinner-sm inline-block"></div>
                  } @else {
                     {{ 'pages.index-page.try.submit' | translate }}
                  }
               </button>
            </form>
            @if (reading) {
               <p class="text-slate-500 text-sm mt-3" aria-live="polite">{{ 'pages.index-page.try.reading' | translate }}</p>
            }
            @if (errorKey) {
               <p class="text-red-500 text-sm mt-3" role="alert">{{ errorKey | translate }}</p>
            }
         } @else {
            <!-- The demo: the visitor's own catalogue, searched -->
            <article class="glass rounded-3xl p-6 max-w-2xl mx-auto text-left flex flex-col gap-4 min-w-0" id="shop-demo">
               <p>{{ 'pages.index-page.try.ready' | translate: { count: shop.productCount, name: shop.name } }}</p>
               <app-shop-search [shopId]="shop.id" [examples]="true" />
               <div class="flex flex-wrap gap-3 items-center">
                  <button type="button" id="install" (click)="install()"
                     class="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-xl px-6 py-3 transition">
                     {{ 'pages.index-page.try.install' | translate }}
                  </button>
                  <button type="button" class="text-slate-500 hover:text-slate-700 font-semibold" (click)="another()">
                     {{ 'pages.index-page.try.another' | translate }}
                  </button>
               </div>
            </article>
         }

         <!-- How it works: three short steps; the subtitle above already says why -->
         <section class="py-10" aria-labelledby="how-heading">
            <h2 id="how-heading" class="sr-only">{{ 'pages.index-page.how.title' | translate }}</h2>
            <ol class="flex flex-col md:flex-row md:justify-center gap-3 md:gap-8 w-fit md:w-auto mx-auto text-left text-sm text-slate-600 dark:text-slate-300">
               @for (step of ['step1', 'step2', 'step3']; track step; let i = $index) {
                  <li class="flex items-center gap-2 md:whitespace-nowrap">
                     <span class="size-6 shrink-0 inline-flex items-center justify-center rounded-full border border-current text-xs font-semibold">{{ i + 1 }}</span>
                     <span>{{ 'pages.index-page.how.' + step | translate }}</span>
                  </li>
               }
            </ol>
         </section>
      </div>
   </section>
</main>
<app-footer />
